// extracted by mini-css-extract-plugin
export default {"modal__content":"modal_modal__content__TCiVx","header":"modal_header__nSd8T","body":"modal_body__hEDN3","title":"modal_title__7k26C","close":"modal_close__VHQvX"};